import { Component, Output, EventEmitter, Input } from '@angular/core';
import { ListView, ListViewField } from '../../model/list-view';

@Component({
    selector: 'zx-list-view-sort',
    templateUrl: './list-view-sort.component.html',
    styleUrls: ['./list-view-sort.component.css']
})
export class ListViewSortComponent {

    private _field: ListViewField;

    @Output() valueChange: EventEmitter<any> = new EventEmitter();

    @Input() set field(v: ListViewField) {
        if (v) {
            this._field = v;
        }
    }
    get field() {
        return this._field;
    }

    get value() {
        try {
            return this.field.sort.value;
        } catch (err) {
            return null;
        }
    }

    asc() {
        if (this.field.sort.value == 'asc') {
            this._field.sort.value = null;
        } else {
            this._field.sort.value = 'asc';
        }
        this.valueChange.emit();
    }
    desc() {
        if (this.field.sort.value == 'desc') {
            this._field.sort.value = null;
        } else {
            this._field.sort.value = 'desc';
        }
        this.valueChange.emit();
    }
}